import {executeQuery} from "@/main";
import subscriberKeyByEsmoId from 'raw-loader!./graphql/query/subscriberKeyByEsmoId.graphqls';
import subscriberKeyByEsmoIdAndLastName from 'raw-loader!./graphql/query/subscriberKeyByEsmoIdAndLastName.graphqls';
import mailPreferences from 'raw-loader!./graphql/query/mailPreferences.graphqls';
import areasOfInterest from 'raw-loader!./graphql/query/areasOfInterest.graphqls';
import saveMailPreferences from 'raw-loader!./graphql/mutation/saveMailPreferences.graphqls';
import saveAreasOfInterest from 'raw-loader!./graphql/mutation/saveAreasOfInterest.graphqls';
import unsubscribe from 'raw-loader!./graphql/mutation/unsubscribe.graphqls';
import {useUserStore} from "@/store/userStore";

export default class AppService {
    subscriberKeyByEsmoId(esmoId) {
        const userStore = useUserStore()
        if(userStore.user && userStore.user.token != null){
            return executeQuery(userStore.user.token, subscriberKeyByEsmoId, {esmoId})
        }
    }
    subscriberKeyByEsmoIdAndLastName(esmoId,lastName) {
        const userStore = useUserStore()
        if(userStore.user && userStore.user.token != null){
            return executeQuery(userStore.user.token, subscriberKeyByEsmoIdAndLastName, {esmoId,lastName})
        }
    }
    mailPreferences(contactId) {
        return executeQuery(null, mailPreferences, {contactId})
    }

    async areasOfInterest(contactId) {
        return executeQuery(null, areasOfInterest, {contactId})
    }

    saveMailPreferences(mailPreferences, jobId, recordTypeID, utmSource, utmMedium, utmCampaign,optOutReason) {
        return executeQuery(null, saveMailPreferences, {
            mailPreferences,
            jobId,
            recordTypeID,
            utmSource,
            utmMedium,
            utmCampaign,
            optOutReason
        })
    }
    saveAreasOfInterest(areasOfInterest) {
        return executeQuery(null, saveAreasOfInterest, {areasOfInterest})
    }
    unsubscribe(subscriberKey,emailAddress, jobId, recordTypeID, utmSource, utmMedium, utmCampaign,optOutReason) {
        return executeQuery(null, unsubscribe, {
            subscriberKey,
            emailAddress,
            jobId,
            recordTypeID,
            utmSource,
            utmMedium,
            utmCampaign,
            optOutReason
        })
    }
}
